import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
import { getQueryString } from '@/utils/common'

// 获取配置项信息
export const getConfigData = async (params: object) => {
  return await GET({
    url: Api.getConfigData,
    headers: { 'Client-Id': 'iss_courier' },
    params: {
      // cityId: getQueryString('cityId'),
      apiVersion: getQueryString('versionname'),
      ...params
    },
    showError: false
  })
}
// 获取信息
export const getHomeData = async (params: object) => {
  return await GET({
    url: Api.getHomeData,
    headers: { 'Client-Id': 'iss_courier' },
    params: {
      // cityId: getQueryString('cityId'),
      ...params
    },
    showError: false
  })
}
// 去购买
export const buyInsurance = async (params: object) => {
  return await GET({
    url: Api.buyInsurance,
    headers: { 'Client-Id': 'iss_courier' },
    params: {
      // cityId: getQueryString('cityId'),
      ...params
    },
    showError: false
  })
}
// 查询城市有没有开通
export const govConfig = async (params: object) => {
  return await GET({
    url: Api.govConfig,
    headers: { 'Client-Id': 'iss_courier' },
    params: {
      // cityId: getQueryString('cityId'),
      ...params
    },
    showError: false
  })
}
